import mergeConfig from 'coact/config/mergeConfig'
import invoicesSchema from './invoices/schema.js'

const config = {
  models: {
    invoices: {
      title: 'invoices',
      schema: invoicesSchema,
    },
  },
}

export default fullConfig => mergeConfig(fullConfig, config)
